import { initialize, MetaItem, Meta } from '@smart-x/rum';

import { getNats } from 'nats';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';

import { User } from '../stores/UserStore/UserStore.types';


const { logger, metas, transport, pushLog, pushError, pushEvent, pushMetric } = initialize({
  component: { name: 'cam4-client' },
  consoleLogLevel: 'silent',
  transportLogLevel: 'error',
  logSignals: false,
});

let userMeta: MetaItem<Pick<Meta, 'user'>> = {
  user: {
    id: '0',
    username: 'N/A',
  },
};
metas.add(userMeta);

function initRum() {
  const version = ConfigurationService.get(ConfigurationKeys.UI_VERSION) as string;
  metas.add({
    component: {
      name: 'cam4-client',
      version,
    },
  });
}

async function setRumUser(user: User) {
  metas.remove(userMeta);
  userMeta = {
    user: {
      id: user.userId.toString() || '0',
      username: user.username || 'N/A',
    },
  };
  metas.add(userMeta);

  await transport.drain();
  const connection = await getNats(user);
  if (connection) {
    transport.nats({ connection });
  }
}

// Used by dumpster
window.cam4Rum = { logger, metas, transport, pushLog, pushError, pushEvent, pushMetric };

export { initRum, setRumUser, pushLog, pushError, pushEvent, pushMetric, logger };
